import { getSupportBankList, sendSmsForBank, bindBankCardForApply, cardbin, getCardStatus, sendSmsForValidBank, getWithdrawCards, getRepayBankCards, setAutoFlag, validBankCardForApply, bindBankCard, getPmtUrl } from '@/api/bank'
import { getLoanConfig } from '@/api/loan'
import { some as _some, map as _map } from 'lodash'
const actions = {
    getSupportBankList({ commit }, payload) {
        payload = payload || { applyId: 0 }
        getSupportBankList(payload)
            .then(data => {
                commit('SET_BANK_LIST', data)
            })
    },
    sendSmsForBank({ commit }, payload) {
        return sendSmsForBank(payload)
            .then(data => {
                commit('SET_BANK_SMS', data)
                return Promise.resolve()
            })
    },
    sendSmsForValidBank({ rootState }, payload) {
        return sendSmsForValidBank({
            applyId: rootState.apply.applyInfo.applyId,
            ...payload
        }).then(() => {
            return Promise.resolve()
        })
    },
    bindBankCardForApply({ state }, payload) {
        return bindBankCardForApply({
            ...payload,
            ...state.sms
        })
    },
    bindBankCard({ state }, payload) {
        return bindBankCard({
            ...payload,
            ...state.sms
        })
    },
    getPmtUrl({ commit }, payload) {
        return getLoanConfig()
            .then((data) => {
                let loanDomain = '';
                data.url.forEach((item) => {
                    for (let key in item) {
                        if (key == 'LoanBase') {
                            loanDomain = item[key];
                        }
                    }
                })
                payload.callback = loanDomain + '/pmt/callback/valid?redirectUrl=' + encodeURIComponent(payload.callback);
                return getPmtUrl({
                        ...payload,
                    })
                    .then((data1) => {
                        return Promise.resolve(data1);
                    })
            })
    },
    validBankCardForApply({ commit }, payload) {
        commit('null')
        return validBankCardForApply(payload)
    },
    cardbin({ commit }, payload) {
        commit('null')
        return cardbin({ cardNo: payload })
    },
    getBankCardStatus({ commit }) {
        return getCardStatus().then(data => {
            commit('SET_CARD_INFO', data)
            return Promise.resolve()
        })
    },
    getBankCards({ commit }) {
        getRepayBankCards().then(data => {
            commit('SET_REPAY_BANKCARD', data.bindCards)
        })
        getWithdrawCards().then(data => {
            commit('SET_WITHDRAW_BANKCARD', data.myWithdrawBankCards)
        })
    },
    getRepayBankCardList({ commit }) {
        getRepayBankCards().then(data => {
            commit('SET_REPAY_BANKCARD', data.bindCards)
        })
    },
    setAutoBankFlag({ commit }, payload) {
        commit('null')
        return setAutoFlag(payload)
    }
}

const mutations = {
    'SET_BANK_LIST' (state, payload) {
        state.banks = payload.banks
    },
    'SET_BANK_SMS' (state, payload) {
        state.sms = payload
    },
    'SET_CARD_INFO' (state, payload) {
        state.cardInfo = payload
        state.cardInfo.validBankCard = (state.cardInfo.bindCards && state.cardInfo.bindCards.length > 0) ? true : false
    },
    'SET_REPAY_BANKCARD' (state, payload) {
        state.repayBankCardList = payload
        if (_some(state.repayBankCardList, item => {
                return item.withholdBankCard
            })) {
            state.hasOpen = true
        } else {
            state.hasOpen = false
        }
    },
    'SET_WITHDRAW_BANKCARD' (state, payload) {
        state.withdrawBankCardList = payload
    },
    'SET_AUTO_FLAG' (state, payload) {
        state.repayBankCardList = _map(state.repayBankCardList, (bank) => {
            bank.withholdBankCard = bank.cardId == payload;
            return bank;
        })
    },
    'SET_VALID_BANKCARD' (state, payload) {
        state.cardInfo.validBankCard = payload
    },
    'RESET_BANK' (state) {
        state.cardInfo = {
            validBankCard: false
        }
        state.sms = {
            seqNumber: '',
            verifyCode: '',
            channel: ''
        }
        state.banks = []
        state.hasOpen = false
        state.repayBankCardList = []
        state.withdrawBankCardList = []
    }
}

const state = {
    cardInfo: {
        validBankCard: false
    },
    banks: [],
    hasOpen: false,
    repayBankCardList: [],
    withdrawBankCardList: [],
    sms: {
        seqNumber: '',
        verifyCode: '',
        channel: ''
    }
}
export default {
    state,
    mutations,
    actions
}